import {eatalianoAxios} from "@/data/api/http/axios";
import {DeliveryArea, UpdateDeliveryAreaFields} from "@/data/entities/deliveryArea";

export const listDeliveryAreas = (restaurantId: number): Promise<DeliveryArea[]> => (
    eatalianoAxios
        .get(`/restaurant/area/${restaurantId}`)
        .then(response => response.data)
);

export const deleteDeliveryArea = (
    restaurantId: number,
    deliveryAreaId: number,
): Promise<DeliveryArea[]> => (
    eatalianoAxios
        .delete(`/restaurant/area/${restaurantId}/${deliveryAreaId}`)
        .then(response => response.data)
);
export const createDeliveryArea = (
    restaurantId: number,
    fields: UpdateDeliveryAreaFields,
): Promise<DeliveryArea[]> => (
    eatalianoAxios
        .post(`/restaurant/area/${restaurantId}`, fields)
        .then(response => response.data)
);

export const updateDeliveryArea = (
    restaurantId: number,
    deliveryAreaId: number,
    fields: UpdateDeliveryAreaFields,
): Promise<DeliveryArea[]> => (
    eatalianoAxios
        .put(`/restaurant/area/${restaurantId}/${deliveryAreaId}`, fields)
        .then(response => response.data)
);